<SidebarShell
  :logo="short_logo"
  :brand_title="brand_name"
  :brand_subtitle="brand_subtitle"
  :initials="initials"
  :full_name="full_name"
  :is_admin="is_admin"
  @brand-click="select_global_portfolio"
>
  <!-- ✅ FORWARD SIDEBAR HEADER ACTIONS (X BUTTON) -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions"></slot>
  </template>

  <!-- CONTEXT: hidden for DBE, kept here for future property/context switching. -->
  <template v-if="false" #context>
    <SidebarContext
      :main_label="selected_portfolio"
      :sub_label="portfolio_context_subtitle"
      :items="tilesFormatted"
      :active_id="local_active_property"
      :open="dropdownOpen"
      @toggle="toggleDropdown"
      @select="select_tile_directly"
    >
      <template #top>
        <div
          class="sidebar-context-top border-bottom border-secondary pb-2 mb-2 cursor-pointer"
          @click="select_global_portfolio"
        >
          <p class="text-white fw-light text-xs mb-2">{{ entity_name }}</p>
          <p class="text-white-50 fw-light text-xxs mb-0">
            National Education View
          </p>
        </div>
      </template>
    </SidebarContext>
  </template>

  <!-- MENU -->
  <template #menu>
    <div class="sidebar-menu sidebar-menu-list px-3 mt-3">
      <div
        v-for="item in menuItems"
        :key="item.key"
        class="sidebar-menu-item d-flex align-items-center py-2 ps-2 rounded cursor-pointer"
        :class="[
          active_menu_item === item.key
            ? 'bg-dark text-white border-start border-3 border-primary'
            : 'text-white-50 hover-bg-dark'
        ]"
        :aria-label="item.label"
        @click="select_menu_item(item.key)"
      >
        <i
          :class="[
            item.icon,
            'sidebar-menu-icon',
            'me-2',
            active_menu_item === item.key ? 'text-white' : 'text-white-50'
          ]"
          :aria-label="item.label"
        ></i>

        <p class="sidebar-menu-label sidebar-menu-text fw-light text-xs mb-0">
          {{ item.label }}
        </p>
      </div>
    </div>
  </template>
</SidebarShell>
